module.exports = __webpack_public_path__ + "img/image30.a5609136.jpg";